module.exports = __webpack_public_path__ + "static/media/rambu pele 3WEB.0d250d22.jpg";